class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      // 有些元素不想要自动提交表单，想要手动提交
      if (!event.target.hasAttribute("data-no-auto-submit")) {
        this.onSubmitHandler(event);
      }
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('change', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.section = this.closest(".shopify-section");
    this.stickyHeader = document.querySelector("sticky-header");

    this.customFilterContainer = document.querySelector('[data-custom-filter-loading-container]');
  }

  // Submit finally
  onFinished() {
    // document.body.scrollIntoView({ behavior: 'smooth' });
    if (this.stickyHeader.hideHeaderOnScrollUp()) {
      setTimeout(() => {
        this.stickyHeader.hide();
      }, 500);
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      const facetForm = document.querySelector('facet-filters-form');
      FacetFiltersForm.renderPage(searchParams, null, false).finally(() => facetForm?.onFinished());
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static async renderPage(searchParams, event, updateURLHash = true, useCache = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, .product-count--mb .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }
    if (this.customFilterContainer) {
      this.customFilterContainer.classList.add('loading');
    }

    for (const section of sections) {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      if (useCache) {
        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
          : await FacetFiltersForm.renderSectionFromFetch(url, event);
      } else {
        await FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    }

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static async renderSectionFromFetch(url, event) {
    return fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderCustomFilters(html, event);
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.renderCanonical(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderCustomFilters(html, event);
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderCanonical(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderCanonical(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const currentCanonical = document.querySelector('[rel="canonical"]');
    const page = Number(parsedHTML.querySelector(".pagination__item[aria-current='page'][data-page]")?.getAttribute('data-page'));
    if (currentCanonical && !isNaN(page) && page > 0) {
      const oldHref = currentCanonical.getAttribute('href');
      let urlObject = new URL(oldHref);
      if (page > 1) {
        urlObject.searchParams.set('page', page)
      } else {
        urlObject.searchParams.delete('page');
      }
      currentCanonical.setAttribute('href', urlObject.href);
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    if (this.customFilterContainer) {
      this.customFilterContainer.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, .product-count--mb .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderCustomFilters(html, event) {
    const customFilterContainer = document.querySelector('[data-custom-filter-loading-container]');
    if (!customFilterContainer) return;

    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const containerFromFetch = parsedHTML.querySelector('[data-custom-filter-loading-container]');
    const containerFromDom = document.querySelector('[data-custom-filter-loading-container]');
    containerFromDom.innerHTML = containerFromFetch.innerHTML;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event, useCache = true) {
    FacetFiltersForm.renderPage(searchParams, event, true, useCache).finally(() => this.onFinished());
  }

  onSubmitHandler(event, useCache = true) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event, useCache);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event, useCache);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url).finally(() => this.onFinished());
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.rangeLowerBound = this.querySelector('.price-range__range-group input:first-child');
    this.rangeHigherBound = this.querySelector('.price-range__range-group input:last-child');
    this.textInputLowerBound = this.querySelector('[data-input-label-price-from]');
    this.textInputHigherBound = this.querySelector('[data-input-label-price-to]'); // Select whole text on focus for text field to improve user experience

    this.textInputLowerBound.addEventListener('keydown', this.onKeyDown.bind(this));
    this.textInputHigherBound.addEventListener('keydown', this.onKeyDown.bind(this));
    this.setMinAndMaxValues();

    this.textInputLowerBound.addEventListener('focus', () => {
      return this.textInputLowerBound.select();
    });
    this.textInputHigherBound.addEventListener('focus', () => {
      return this.textInputHigherBound.select();
    }); // Keep in sync the range with the text input fields

    this.textInputLowerBound.addEventListener('change', (event) => {
      const input = event.currentTarget;
      const value = Number(input.value);
      const min = Number(input.getAttribute('data-min') ?? input.min);
      const max = Number(input.getAttribute('data-max') ?? input.max);
      input.value = Math.max(Math.min(parseInt(value), parseInt(this.textInputHigherBound.value || max) - 1), min);
      this.rangeLowerBound.value = input.value;

      this.rangeLowerBound.parentElement.style.setProperty('--range-min', "".concat(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max) * 100, "%"));
    });
    this.textInputHigherBound.addEventListener('change', (event) => {
      const input = event.currentTarget;
      const value = Number(input.value);
      const min = Number(input.getAttribute('data-min') ?? input.min);
      const max = Number(input.getAttribute('data-max') ?? input.max);
      input.value = Math.min(Math.max(parseInt(value), parseInt(this.textInputLowerBound.value || min) + 1), max);
      this.rangeHigherBound.value = input.value;

      this.rangeHigherBound.parentElement.style.setProperty('--range-max', "".concat(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max) * 100, "%"));
    });

    this.rangeLowerBound.addEventListener('change', (event) => {
      this.textInputLowerBound.value = event.target.value;

      this.textInputLowerBound.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    });
    this.rangeHigherBound.addEventListener('change', (event) => {
      this.textInputHigherBound.value = event.target.value;

      this.textInputHigherBound.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    }); // We also have to bound the two range sliders

    this.rangeLowerBound.addEventListener('input', (event) => {
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1); // Bound the value

      event.target.parentElement.style.setProperty('--range-min', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
      this.textInputLowerBound.value = event.target.value;
    });
    this.rangeHigherBound.addEventListener('input', (event) => {
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1); // Bound the value

      event.target.parentElement.style.setProperty('--range-max', "".concat(parseInt(event.target.value) / parseInt(event.target.max) * 100, "%"));
      this.textInputHigherBound.value = event.target.value;
    });
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const minInput = this.textInputLowerBound;
    const maxInput = this.textInputHigherBound;
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 * 筛选侧边栏，移动端显示为 Drawer
 */
class FacetsVerticalDrawer extends HTMLElement {
  constructor() {
    super();
    this.querySelector(".facets-vertical-drawer__overlay")?.addEventListener("click", this.close.bind(this));
  }

  open() {
    this.classList.add("open");
  }

  close() {
    this.classList.remove("open");
  }
}

customElements.define('facets-vertical-drawer', FacetsVerticalDrawer);


/**
 * 筛选侧边栏 Drawer 的启动按钮
 */
class FacetsVerticalDrawerLauncher extends HTMLElement {
  constructor() {
    super();

    /** @type {FacetsVerticalDrawer} */
    this.drawer = document.querySelector("facets-vertical-drawer");

    this._onClick = this.onClick.bind(this);
  }

  onClick() {
    this.drawer.open();
  }

  connectedCallback() {
    this.addEventListener("click", this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
  }
}

customElements.define('facets-vertical-drawer-launcher', FacetsVerticalDrawerLauncher);


/**
 * 筛选侧边栏 Drawer 的关闭按钮
 */
class FacetsVerticalDrawerCloseButton extends HTMLElement {
  constructor() {
    super();

    /** @type {FacetsVerticalDrawer} */
    this.drawer = document.querySelector("facets-vertical-drawer");

    this._onClick = this.onClick.bind(this);
  }

  onClick() {
    this.drawer.close();
  }

  connectedCallback() {
    this.addEventListener("click", this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
  }
}

customElements.define('facets-vertical-drawer-close-button', FacetsVerticalDrawerCloseButton);

/**
 * 分页
 */
class FacetsPaginate extends HTMLElement {
  constructor() {
    super();

    /** @type {FacetsVerticalDrawer} */
    this.input = document.querySelector("facet-filters-form input[data-facets-paginate]");
    this.facetForm = document.querySelector("facet-filters-form form");

    const items = this.querySelectorAll("a[href][data-page]");
    for (const item of items) {
      item.addEventListener("click", (e) => {
        if (item.hasAttribute("disabled")) return;
        const page = item.getAttribute("data-page");
        this.input.value = Number(page);
        this.facetForm.dispatchEvent(new CustomEvent("change"));
        e.preventDefault();
      });
    }
  }
}

customElements.define('facets-paginate', FacetsPaginate);

// 移动端悬浮筛选栏
(function () {
  const container = document.querySelector("#ProductGridContainer");
  const filters = document.querySelector("#main-collection-filters .facets-container");
  const onScroll = () => {
    if (Math.abs(container.offsetTop - filters.parentElement.offsetTop) < 1) {
      filters.classList.remove('is--sticky');
    } else if (window.innerHeight + window.scrollY > container.offsetTop + container.clientHeight) {
      filters.classList.remove('is--sticky');
    } else {
      filters.classList.add('is--sticky');
    }
  };
  window.addEventListener("scroll", onScroll);
  onScroll();
})();